import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import {
  BackgroundColors,
  PrimaryColors,
  SurfaceColors,
  TextColors,
  TextOpacities,
  Theme,
} from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const useStyles = makeStyles(
  (muiTheme) => ({
    wrapper: {},
    introContent: {
      backgroundColor: SurfaceColors.light,
      padding: muiTheme.spacing(6.5, 3.75),

      [muiTheme.breakpoints.up('md')]: {
        padding: muiTheme.spacing(6.5, 12.5),
      },
    },
    introTop: {
      borderRadius: '4px',
    },
    jumplinksContainer: {
      marginBottom: muiTheme.spacing(3),

      [muiTheme.breakpoints.down('sm')]: {
        marginBottom: muiTheme.spacing(6),
        padding: muiTheme.spacing(0),
      },
      [muiTheme.breakpoints.up('md')]: {
        marginTop: muiTheme.spacing(1),
      },
    },
    partnerIntro: {
      paddingBottom: muiTheme.spacing(5),
      marginBottom: muiTheme.spacing(2),

      [muiTheme.breakpoints.up('md')]: {
        padding: muiTheme.spacing(0, 6, 0, 0),
      },
    },
    summaryBlock: {
      borderTop: `1px solid ${hexToRGBA(TextColors.dark, TextOpacities.light4)}`,
      paddingTop: muiTheme.spacing(6.5),
      paddingBottom: muiTheme.spacing(8.5),
    },
    sidebar: {
      [muiTheme.breakpoints.down('sm')]: {
        paddingBottom: muiTheme.spacing(4),
      },
    },
    tagChip: {
      ...typography.caption,
      background: BackgroundColors.light,
      color: PrimaryColors.main,
      margin: muiTheme.spacing(0, 1, 1, 0),
      padding: muiTheme.spacing(1),
    },
    tagsContainer: {},
    tagsHeading: {
      '&.MuiTypography-root': {
        color: hexToRGBA(TextColors.dark, 0.8),
        marginBottom: '20px',
        textTransform: 'uppercase',
      },
    },
  }),
  { name: 'GenTPSIntroContent' },
);

export default useStyles;
